import Toolbar from '@/components/toolbar';
import BottomNav from '@/components/bottom-nav';
import HistoryRepeatable from '../history-repeatable/history-repeatable.vue';

export default {
  name: 'HistoryContainer',
  components: {
    Toolbar,
    HistoryRepeatable,
    BottomNav
  },
  created() {
    this.getSubmissionArray();
  },
  data() {
    return {
      submissionArray: ''
    };
  },
  methods: {
    getSubmissionArray() {
      this.submissionArray = JSON.parse(localStorage.getItem('submission-array'));
    },
    goHome() {
      this.$router.push('/');
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/service-log/history/history-container/history-container.js